import { SegmentType } from '@ve-pro/enums/segment'
import type {
  SegmentCollection,
  SegmentSticker,
  SegmentText,
  SegmentVideo,
  RatioProperties,
} from '@ve-pro/types/track.type'

export function isSupportPosition(
  segment: SegmentCollection,
): segment is SegmentVideo | SegmentText | SegmentSticker {
  return [SegmentType.Video, SegmentType.Text, SegmentType.Sticker].includes(
    segment.type,
  )
}

export function isSupportMoreRatio(
  segment: SegmentCollection,
): segment is SegmentVideo | SegmentText | SegmentSticker {
  return [SegmentType.Video, SegmentType.Text, SegmentType.Sticker].includes(
    segment.type,
  )
}
